module.exports = __webpack_public_path__ + "img/jiahao.a2b42b90.svg";